<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title style="background: var(--v-primary-base); position: sticky; top: 75px; z-index: 1; color: white !important">
                <v-icon large left style="color: white">mdi-account-cash</v-icon>
                <span class="title font-weight-light">Configuração do Relatório de Acompanhamento de Doação</span>
                <v-spacer/>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="GerarRelatorio()" v-on="on"><v-icon>mdi-text-box-check</v-icon></v-btn>
                    </template>
                    <span>Gerar Relatório</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="LimparFiltros()" v-on="on"><v-icon>mdi-eraser</v-icon></v-btn>
                    </template>
                    <span>Limpar</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row>                    
                    <v-col cols="12" sm="12" md="6">
                        <v-autocomplete v-model="filtro.doadorId" :items="doadores" :loading="isDoadorLoading" :search-input.sync="onSearchDoador" clearable
                          item-text="nome" item-value="id" label="Doador Indicador" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-select v-model="filtro.regiaoId" label="Região/Grupo" :items="regioes"
                          item-value="id" item-text="nome" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field type="number" v-model.number="filtro.ano" label="Ano" placeholder="Ano" dense outlined/>
                    </v-col>
                    <v-col cols="12">
                        <v-switch v-model="filtro.doadoresInativos" label="Inibir doadores inativos que não tenham recebíveis no período" style="margin-top: -5px"/>
                    </v-col>                    
                </v-row>
            </v-card-text>
        </v-card>
    </master-page>
</template>

<script>
import { DoadorService, RegiaoService } from '@/core/services/doacao';

export default {
    watch: { 
        onSearchDoador(val){
            if(this.isDoadorLoading) return;
            if(!val) return;

            this.isDoadorLoading = true;
            const doadorService = new DoadorService();
            doadorService.AutoComplete(val)
            .then(
                res=>{
                    this.doadores = res.data
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
            .finally(() => (this.isDoadorLoading = false))
        }
    },
    data: () => ({
        filtro: {          
            doadorId: 0,  
            regiaoId: null,
            doadoresInativos: false,            
            ano: new Date().getFullYear(),
        },        
        doadores: [],
        regioes: [],
        isDoadorLoading: false,
        onSearchDoador: null

    }),
    methods: {
        GerarRelatorio(){
            this.AbrirJanela('relatorioAcompanhamentoDoacoes')
        },
        LimparFiltros(){
            this.filtro = {
                doadorId: 0,
                regiaoId: null,
                doadoresInativos: false,            
                ano: new Date().getFullYear(),
            }
        },
        AbrirJanela(rota) {
            let routeLink = this.$router.resolve({ name: rota,
                query:{
                    doadorId: this.filtro.doadorId,
                    regiaoId: this.filtro.regiaoId,
                    doadoresInativos: this.filtro.doadoresInativos,
                    ano: this.filtro.ano
                }
            });
            window.open(routeLink.href,'_blank');
        },
    },
    mounted(){
        const regiaoService = new RegiaoService();
        regiaoService.ListarTudo()
        .then(
            res => {
                this.regioes = res.data.items;
                this.regioes.unshift({
                    id: null,
                    nome: '---NENHUM---'
                });
            },
            err => this.$swal('Aviso', err.message, 'error')
        );
    }
}

</script>
